import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';

import selectors from 'state/selectors';
import utils from 'utils';

import Header from 'components/Modal/Header';
import Modal from 'components/Modal';

const Subtitle = styled.h5`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-weight: 300;
  letter-spacing: -0.5px;
  line-height: 19px;
  margin-bottom: 10px;
`;

const RetryErrors = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);
  const { errorNumber, func } = modalProps;

  return (
    <>
      <Header title={t('retry_errors_modal_title')} />
      <Subtitle>
        {t('are_you_sure_you_want_to_unlock')} {errorNumber}{' '}
        {errorNumber === 1 ? t('selected_document') : t('selected_documents')}?
      </Subtitle>
      <Modal.Footer confirmAction={func} confirmText={t('confirm')} closeButtonText={t('cancel')} />
    </>
  );
};

export default RetryErrors;
